import {HttpErrorResponse} from '@angular/common/http';
import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import jsPDF from 'jspdf';
import {JhiAlertService, JhiEventManager} from 'ng-jhipster';
import {LocalStorageService} from 'ngx-webstorage';
import {forkJoin, Observable, Subject, Subscription} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {Principal} from '@core/index';
import {Area, netHouses} from '@shared/model/area.model';
import {AreaService} from '@shared/services/area.service';
import {DonViService} from '@entities/don-vi';
import {GiongService} from '@entities/giong';
import {IGiong} from '@entities/giong/giong.model';
import {Crops, IGuidelines} from '@entities/canh-tac/canh-tac.model';
import {CanhTacService} from '@entities/canh-tac/canh-tac.service';

@Component({
  selector: 'app-canh-tac-detail',
  templateUrl: './canh-tac-detail.component.html',
})
export class CanhTacDetailComponent implements OnInit {
  lo: Crops;
  loId: any;
  area$: Area[];
  tbCropTypeId$: any;
  netHouses$: netHouses[];
  supPlies$: IGiong[];
  guideLine$: IGuidelines[];
  eventSubscriber: Subscription;
  customerData: any;
  customerId = null;
  private unsubscribeAll = new Subject();
  elementType: 'img';
  constructor(
    private activatedRoute: ActivatedRoute,
    private canhTacService: CanhTacService,
    private eventManager: JhiEventManager,
    private alertService: JhiAlertService,
    private localStorage: LocalStorageService,
    private titleService: Title,
    private giongService: GiongService,
    private areaService: AreaService,
    private router: Router,
    private donViService: DonViService,
    private principal: Principal,
    private translate: TranslateService,
  ) {
    this.lo = new Crops();
    this.loId = null;
    this.tbCropTypeId$ = [];
    this.customerData = [];
  }

  ngOnInit() {
    this.principal
      .getAuthenticationState()
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((user) => {
        if (user) {
          this.customerId = user.customerId;
          if (user.customerId) {
            this.lo.tbCustomerId = this.lo.tbCustomerId || user.customerId;
            this.getArea(this.lo.tbCustomerId);
          } else {
            this.getArea();
          }
        }
      });
    this.titleService.setTitle(
      this.translate.instant(
        'entities.canh-tac.canh-tac-detail.Chi tiết lô_title',
      ),
    );
    this.localStorage.clear('lo.LoId');
    this.changedDetailLo();
    this.activatedRoute.data.subscribe(({lo}) => {
      setTimeout(() => {
        if (lo !== undefined) {
          this.lo = lo;
          this.loId = this.lo.id;
          this.localStorage.store('lo.LoId', this.loId);
          this.canhTacService.guideLine(lo.guideType).subscribe((res: any) => {
            this.guideLine$ = res.body ? res.body : [];
          });
          this.giongService
            .queryDropdownList(lo.guideType)
            .subscribe((res: any) => {
              this.supPlies$ = res.body ? res.body : [];
            });
          this.canhTacService
            .listCropType(lo.guideType)
            .subscribe((res: any) => {
              this.tbCropTypeId$ = res.body ? res.body : [];
            });
          this.donViService.dropdown().subscribe((data: any) => {
            this.customerData = data.body;
          });
          if (lo.areaId) {
            this.getNetHouses(lo.areaId);
          } else {
            this.getNetHouses(0);
          }
          // if (this.activatedRoute.snapshot.paramMap.get("env")) {
          //   this.router.navigate([{ outlets: { popup: ['chi-so-va-dieu-khien', this.loId, this.activatedRoute.snapshot.paramMap.get("env")] }}]);
          // }
        }
      }, 0);
    });
  }

  update() {
    if (this.lo.id !== null) {
      this.subscribeToSaveResponse(
        forkJoin([this.canhTacService.update(this.lo)]),
      );
    }
  }
  changedDetailLo() {
    this.eventSubscriber = this.eventManager.subscribe(
      'loDetailModification',
      () => this.reLoadLo(),
    );
  }
  reLoadLo() {
    this.canhTacService.find(this.loId).subscribe((res: any) => {
      this.lo = res.body ? res.body : null;
    });
  }
  private updateSuccess(result: any) {
    this.eventManager.broadcast({
      name: 'loListModification',
      content: 'Lo',
    });
  }

  private onUpdateError(msg: string) {
    this.alertService.error(msg, null, null);
  }

  private subscribeToSaveResponse(result: Observable<any[]>) {
    result.subscribe(
      ([]) =>
        setTimeout(() => {
          this.updateSuccess("Success to save your're information!");
        }, 0),
      (error: HttpErrorResponse) =>
        setTimeout(() => {
          this.onUpdateError(error.error.title);
        }, 0),
    );
  }
  getNetHouses(id: number) {
    if (id) {
      this.areaService.listNetHousesByArea(id).subscribe((res: any) => {
        this.netHouses$ = res.body ? res.body : [];
      });
    } else {
      this.areaService.listNetHousesAll().subscribe((res: any) => {
        this.netHouses$ = res.body ? res.body : [];
      });
    }
  }
  onCustomerChange(event: any) {
    if (event) {
      this.lo.areaId = null;
      this.getArea(event);
    }
  }

  getArea(customerId = ''): void {
    this.areaService
      .listArea({customerId: customerId})
      .subscribe((res: any) => {
        this.area$ = res.body ? res.body : [];
      });
  }
  onAreaChange(event: any) {
    if (event) {
      this.lo.areaId = event;
      this.getNetHouses(event);
    }
  }
  onNetHousesChange(event: any) {
    this.lo.netHouseId = event;
  }
  onSupPliesChange(event: any) {
    this.lo.tbSuppliesId = event;
  }
  onGuideLineChange(event: any) {
    this.lo.tbGuidelineId = event;
  }
  QRpdfCode() {
    const qrcode = document.getElementById('qrcode');
    const doc = new jsPDF();
    const width = doc.internal.pageSize.getWidth();
    const height = doc.internal.pageSize.getHeight();
    // v14 renders canvas by default, fallback to img for compatibility
    const canvas = qrcode.getElementsByTagName('canvas')[0];
    const img = qrcode.getElementsByTagName('img')[0];
    let imageData: string;
    if (canvas) {
      imageData = canvas.toDataURL('image/png');
    } else if (img) {
      imageData = this.getBase64Image(img);
    }
    if (imageData) {
      doc.addImage(imageData, 'PNG', width / 2 - 50, height / 2 - 50, 100, 100);
      doc.save('QRcode.pdf');
    }
  }

  getBase64Image(img) {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    return canvas.toDataURL('image/png');
  }
  onViewDetail(event: Event, id: number): void {
    event.preventDefault();
    this.router.navigate(['/danh-sach-cong-viec', id]);
  }

  getStatusLabel(status: string): string {
    const map: Record<string, string> = {
      STATUS_ARE_ACTIVE:
        'entities.canh-tac.canh-tac-detail.Đang canh tác_status',
      STATUS_FINISHED: 'entities.canh-tac.canh-tac-detail.Đã thu hoạch_status',
    };
    const key =
      map[status] || 'entities.canh-tac.canh-tac-detail.Chưa cập nhật_status';
    return this.translate.instant(key);
  }
}
